var MarbV2 = (function () {

    var _initialized = false,
        _properties = {};
    var INSTALLATION_CALENDAR;

    var marb = {
        initialize: function (params) {
            if (!_initialized) {
                for (var p in params) {
                    _properties[p] = params[p];
                }
                _initialized = true;
            }
        },
        Commons: {
            getProp: function (p) {
                if (p in _properties) {
                    return _properties[p];
                }
                else {
                    console.warn('Unexistent property request to MarbV2.Commons.getProp', p);
                }
            },
            createCookie: function (name,value,days) {
                var expires = '';
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days*24*60*60*1000));
                    expires = '; expires=' + date.toUTCString();
                }
                document.cookie = name + '=' + value + expires + '; path=/';
            },
            getCookie: function (name) {
                function escape(s) {
                    return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
                }
                var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
                return match ? match[1] : null;
            },
            Track: {
                checkout: {
                    terms: function () {
                        dataLayer.push({'event': 'job-installation-terms'});
                        console.log("{'event': 'job-installation-terms'}");
                    },
                    event: function () {
                        var data = {};
                        switch (arguments.length) {
                            case 3:
                                data = {'ji-product': arguments[0], 'value': arguments[1], 'event': arguments[2]};
                                break;
                            case 7:
                                data = {
                                    'transactionId': arguments[0],
                                    'transactionTotal': arguments[1],
                                    'transactionCurrency': arguments[2],
                                    'transactionProducts': [
                                        {
                                            'sku': arguments[3],
                                            'name': arguments[4],
                                            'price': arguments[1],
                                            'quantity': arguments[5],
                                            'category': arguments[6]
                                        }
                                    ]
                                };
                        }
                        dataLayer.push(data);
                        console.log("Track checkout event --> " + JSON.stringify(data));
                    }
                },
                quote:{
                    medium: function(url, mediumValue, sourceValue, campaingValue){

                        if (url.split('=').length > 1) {
                            return '&utm_medium=' + mediumValue + '&utm_source='+sourceValue+'&utm_campaign='+ campaingValue;
                        } else {
                            return '?utm_medium=' + mediumValue + '&utm_source='+sourceValue+'&utm_campaign='+ campaingValue;
                        }

                    }
                }
            },
            Util: {

                formatCurrency: function (amount) {
                    var symbol = Mv2.Commons.getProp("currencySymbol");
                    var localeDecSep = Mv2.Commons.getProp("localeDecimaSeparator");
                    var localeIntSep = Mv2.Commons.getProp("localeHundredSeparator");

                    var decimalSeparator = Number("1.2").toLocaleString().substr(1, 1);
                    var hundredSeparator = Number("1000").toLocaleString().substr(1, 1);
                    if (isNaN(hundredSeparator)) {
                        hundredSeparator = hundredSeparator.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    } else {
                        //in some computers there is no hundred separator
                        //so we just use an invalid string
                        hundredSeparator = "X";
                    }
                    var browserFormat = amount.toLocaleString();
                    var arParts = String(browserFormat).split(decimalSeparator);
                    var intPart = arParts[0].replace(new RegExp(hundredSeparator, 'g'), localeIntSep);
                    var decPart = (arParts.length > 1 ? arParts[1] : '');
                    decPart = (decPart + '00').substr(0, 2);

                    return symbol + intPart + localeDecSep + decPart;
                },
                maskPhone: function(params){
                    var singleElement = $(params.selector);
                    var maskProperties = params.mask;

                    jQuery(function($){
                        $(singleElement).mask(maskProperties, {clearIfNotMatch: true});
                        $(singleElement).on('click', function(){
                            $(this).val($(this).val().trim());
                        });

                    });
                },
                maskIdentityNumber: function(params){
                    var singleElement = $(params.selector);
                    var maskProperties= params.mask;
                    var taxTypeVal = 'DEFAULT';

                    if (params.typeSelector != null){
                        taxTypeText = $(params.typeSelector).text().trim();
                    }

                    jQuery(function($){
                        $(singleElement).mask(maskProperties[taxTypeText]);
                    });
                },
                calculatePrice: function calculatePrice(config) {
                    const defaultConfig = {
                        onAfterSuccess: function(){}
                    };
                    $.extend(defaultConfig, config);

                    const selectedProductInstallation = $(defaultConfig.productInstallationSelector);
                    $(defaultConfig.calculatingPriceSelector).show();
                    defaultConfig.onBefore();
                    if ($(defaultConfig.locationSelector).val() && selectedProductInstallation.val()) {
                        var ajaxTime = new Date().getTime();
                        var minTime = defaultConfig.minDelayTime;
                        var pids = selectedProductInstallation.val();
                        if(defaultConfig.productIds) { pids = defaultConfig.productIds; }
                        $.getJSON('/productInstallation/pricing',
                            {
                                locationCode: $(defaultConfig.locationSelector).val(),
                                productIds: pids,
                            },
                            function (response) {
                                var totalTime = new Date().getTime()-ajaxTime;

                                if (response.success && response.data.pricing) {
                                    var unitPriceMap = response.data.pricing;
                                    var unitPrice = unitPriceMap[selectedProductInstallation.val()];
                                    var calculatedPrice = (unitPrice.fixedResellerPriceInCents + $(defaultConfig.unitsSelector).val() * unitPrice.variableResellerPriceInCents) / 100;
                                    var price = {value: calculatedPrice, withoutTax: unitPrice.withoutTax};

                                    if(minTime>totalTime){
                                        var delayonSuccess = minTime - totalTime;
                                        setTimeout(function() {
                                            $(defaultConfig.calculatingPriceSelector).hide();
                                            defaultConfig.onSuccess(price);
                                            defaultConfig.onAfterSuccess();
                                        }, delayonSuccess);
                                    }else {
                                        $(defaultConfig.calculatingPriceSelector).hide();
                                        defaultConfig.onSuccess(price);
                                        defaultConfig.onAfterSuccess();
                                    }

                                } else {

                                    if(minTime>totalTime){
                                        var delayOnDefault = minTime - totalTime;
                                        setTimeout(function() {
                                            $(defaultConfig.calculatingPriceSelector).hide();
                                            defaultConfig.onDefault();
                                        }, delayOnDefault);
                                    }else {
                                        $(defaultConfig.calculatingPriceSelector).hide();
                                        defaultConfig.onDefault();
                                    }

                                }
                            }
                        );
                    }else{
                        $(defaultConfig.calculatingPriceSelector).hide();
                        defaultConfig.onDefault();
                    }
                },
                addNextOnEnterBySelector: function (formId, itemsSelector) {
                    $("#"+formId).on('keydown', itemsSelector, function (event) {
                        if (event.which == 13) {
                            event.preventDefault();
                            var $this = $(event.target);
                            var index = parseFloat($this.attr('data-index'));
                            $('[data-index="' + (index + 1).toString() + '"]').focus();
                        }
                    });
                },
                findCep: function findCep(params){
                    var inputValue = $(params.cepSelector).val().padChar(8);
                    if ($.isNumeric(inputValue) && inputValue.length == 8) {
                        $.getJSON("/geo/cep/" + inputValue, function (response) {
                            if (!response.success) {
                                params.onError(response);
                                return;
                            }
                            params.onSuccess(response.data);
                        });
                    } else {
                        params.onValidationError(response);
                    }
                },
                /**
                 * Fetches an image to use as banner.
                 *
                 * @param bannerOptions
                 */
                getBanner: function(bannerOptions) {
                    const isMobile = this.isMobile();
                    const bannerUrl = '/banner/' + bannerOptions.location + '/mobile/';
                    const callback = bannerOptions.callback || function(){};

                    $.ajax(bannerUrl + isMobile, {
                        type: "GET",
                        success: function(result){
                            // /images/banner/
                        	const success = result.success === true;
                            if(success) {
                                $('#' + bannerOptions.bannerId).attr("src", result.data.url);
                                $('#' + bannerOptions.linkId).attr("href", result.data.linkUrl);
                                if (result.data.href) {
                                    $('#' + bannerOptions.linkId).attr("target", "_blank");
                                }
                            } else {
                                $('#' + bannerOptions.linkId).hide();
                                $('#' + bannerOptions.bannerId).hide();
                            }
                            callback(success);
                        }
                    });
                },
                isMobile: function () {
                    var maxWidthMobile = 768;
                    isAndroid = navigator.userAgent.match(/Android/i);
                    isIOS = navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i);

                    isMobileOtros = navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);

                    return $(window).width() <= maxWidthMobile;
                },
                sendingAnimation: {
                    show: function(){
                        $("body").css("overflow", "hidden");
                        $(".sendingIcon").addClass("animating");
                        $(".sendingWrapper").fadeIn(400);
                    },
                    hideAndRedirect: function(url){
                        MarbV2.Commons.Util.sendingAnimation.hide();
                        window.location.replace(url);
                    },
                    hide: function(){
                        $(".sendingIcon").removeClass('animating').addClass("isComplete");
                        setTimeout(function(){
                            $("body").css("overflow", "auto");
                            $(".sendingWrapper").fadeOut(400);
                        }, 1500);
                    }
                }
            },
            initLoaderButtons: function () {
                $.extend($.fn, {
                    loaderButtonInit: function () {
                        $(this).on('click startLoading', function () {
                            const btn = $(this);
                            const originalClass = btn.attr('class');

                            // wrap innerHtml so that it can be hidden
                            btn.wrapInner('<span></span>').children('span').hide();

                            btn
                                .data('original-class', originalClass)
                                .removeClass('btn-default hvr-tr_bx-sh')
                                .addClass('btn btn-secondary loading')
                                .append("<i class='fa fa-circle-o-notch fa-spin fa-fw' aria-hidden='true'></i>")
                                .attr({'disabled': true, 'active': false});

                        });

                        $(this).on('stopLoading', function (e) {
                            const btn = $(e.target);
                            const span = btn.find('span:hidden');

                            if (span.length) {
                                const innerHtml = span.html();
                                btn
                                    .html(innerHtml)
                                    .attr('disabled', false)
                                    .removeClass()
                                    .addClass(btn.data('original-class'));
                                span.detach();

                            }
                        });
                    },
                    loaderButtonStartLoading: function () {
                        if (!$(this).hasClass('btn')) return;
                        $(this).trigger('startLoading');
                    },
                    loaderButtonStopLoading: function () {
                        $(this).trigger('stopLoading');
                    }
                });
            }
        },
        Page: {
            Checkout: {
                calculatePrice: function calculatePrice(options, configOptions) {
                    const config = {
                        productInstallationSelector: "#productInstallationId",
                        locationSelector: "#locationId",
                        unitsSelector: configOptions && configOptions.unitsSelector ? configOptions.unitsSelector : "[name='units']",
                        calculatingPriceSelector:"#calculate-price",
                        minDelayTime: 1500,
                        freeVisit: '',
                        onBefore: function(){
                            $("#locationSelectionReminder").hide();
                            $("#price").hide();
                        },
                        onDefault: function(){
                            $("#locationSelectionReminder").show();
                        },
                        onSuccess: function(){
                            const price = arguments[0];
                            calculatedPrice = price.value;

                            if(price.value != 0) {
                                $("#price").text(MarbV2.Commons.Util.formatCurrency(price.value));
                            } else {
                                $("#price").html(config.freeVisit);
                            }
                            $("#amount").val(price.value);
                            $("#price").show();
                            $("#locationSelectionReminder").hide();
                        }
                    };
                    Mv2.Commons.Util.calculatePrice($.extend(config, options));
                },
                calculatePriceB2B: function calculatePriceB2B(options) {
                    const config = {
                        productInstallationSelector: "#productInstallationId",
                        locationSelector: "#city",
                        unitsSelector: "#units",
                        calculatingPriceSelector:"#calculate-price",
                        minDelayTime: 1500,
                        freeVisit: '',
                        onBefore: function(){
                            $(".final-price").hide();
                            $(".btn-submit").hide();
                            $(".plusTax").hide();
                        },
                        onDefault: function(){

                        },
                        onSuccess: function(){
                            const price = arguments[0];
                            calculatedPrice = price.value;

                            if(price.value != 0){
                                $(".final-price span").show();
                                $("#price").text(MarbV2.Commons.Util.formatCurrency(price.value));
                                if(price.withoutTax){
                                    $(".plusTax").show();
                                }
                            }else{
                                $(".final-price span").hide();
                                $("#price").html(config.freeVisit);
                            }
                            $("#amount").val(price.value);
                            $(".final-price").show();
                            $(".btn-submit").show();
                        }
                    };
                    Mv2.Commons.Util.calculatePrice($.extend(config, options));
                },
                calculatePriceResellers: function calculatePriceResellers(options) {
                    const config = {
                        productInstallationSelector: "#productInstallationId",
                        locationSelector: "#city",
                        unitsSelector: "#units",
                        calculatingPriceSelector: "#calculate-price",
                        minDelayTime: 1500,
                        freeVisit: '',
                        productIds: $.unique($("#productInstallationId :selected,.productIds :selected").map(function(){return this.value;}).get().sort()).sort().join(),
                        onBefore: function () {
                            $(".final-price").hide();
                            $(".btn-submit").hide();
                            $(".plusTax").hide();
                        },
                        onDefault: function () {
                            var units = $('#units').val();
                            var selectedPi = $("#productInstallationId option:selected");
                            var unitPrice = selectedPi.data('varprice');
                            var fixedPrice = selectedPi.data('fixedprice');
                            var mainPrice = 0;
                            if (selectedPi.data('customprice')) {
                                mainPrice = $('#units').unmask() / 100;
                            } else {
                                mainPrice = fixedPrice / 100 + (units * unitPrice / 100 );
                            }
                            calculatedPrice = mainPrice;
                            var withoutTax = $("#productInstallationId option:selected").data('withouttax');
                            var price = {value: calculatedPrice, withoutTax: withoutTax};
                            this.onSuccess(price);
                        },
                        onSuccess: function () {
                            const price = arguments[0];
                            calculatedPrice = price.value + this.getAddOnsPrice(price.unitPriceMap);

                            if (calculatedPrice != 0) {
                                $(".final-price span").show();
                                $("#price").text(MarbV2.Commons.Util.formatCurrency(calculatedPrice));
                                if (price.withoutTax) {
                                    $(".plusTax").show();
                                }
                            } else {
                                $(".final-price span").hide();
                                $("#price").html(config.freeVisit);
                            }
                            $("#amount").val(calculatedPrice);
                            $(".final-price").show();
                            $(".btn-submit").show();
                        },
                        getAddOnsPrice: function (){
                            var unitPriceMap = arguments[0];
                            var products = $('#add-ons-container .product-wrapper');
                            var price = 0;
                            products.each(function(idx, elem){
                                var parent = $(elem);
                                var product = parent.find('.productIds :selected');
                                if( product.length == 0 ){
                                    return;
                                }
                                if( product.val() < 1 ){
                                    return;
                                }
                                var units = parent.find('.addOnsQtys').val();
                                if( units < 1 ){
                                    return;
                                }

                                var unitPrice;
                                var fixedPrice;
                                if (unitPriceMap){
                                    var unitPricing = unitPriceMap[product.val()];
                                    unitPrice = unitPricing.variableResellerPriceInCents;
                                    fixedPrice = unitPricing.fixedResellerPriceInCents;
                                }else{
                                    unitPrice = product.data('varprice');
                                    fixedPrice = product.data('fixedprice');
                                }
                                price += (units * unitPrice /100) + fixedPrice/100;
                            });
                            return price;
                        }
                    };
                    Mv2.Commons.Util.calculatePrice($.extend(config, options));
                },
                Calendar:{
                    init: function init(options){
                        INSTALLATION_CALENDAR = options.calendar;
                        var $calendar = options.calendarSelector;
                        var $timeRange = options.timeRangeSelector;

                        $.datepicker.setDefaults( $.datepicker.regional[ options.lang ] );
                        $calendar.datepicker({
                            showOtherMonths: true,
                            selectOtherMonths: true,
                            dateFormat: "dd/mm/yy",
                            minDate: 0,
                            fixFocusIE: false,
                            beforeShowDay: Mv2.Page.Checkout.Calendar.installationDateCheck,
                            onSelect: function(dateText, inst) {
                                this.fixFocusIE = true;
                                $(this).change().focus();
                            },
                            onClose: function(dateTxt, inst){
                                $(this)[0].checkValidity();
                                Mv2.Page.Checkout.Calendar.doCheckTime(dateTxt, $calendar, $timeRange);
                                this.fixFocusIE = true;
                                this.focus();
                                options.showSelectedDate;
                            }
                        }).click(function(){$(this).focus();});

                        $calendar.on('invalid', function(){
                            return this.setCustomValidity(options.errorMessage);
                        }).on('input blur', function(){
                            return this.setCustomValidity('');
                        });

                        $("#ui-datepicker-div").addClass("ifix-custom-datepicker");

                        $timeRange.on('change',function(){
                            options.showSelectedDate;
                        });
                    },
                    update: function update(options) {
                        var $city = options.citySelector;
                        var $installationType = options.installationTypeSelector;
                        var $calendar = options.calendarSelector;
                        var $timeRange = options.timeRangeSelector;

                        if( Marb.Commons.Utils.isBlank($city.val())){
                            return;
                        }
                        var pids = Mv2.Page.Checkout.Calendar.getSelectedProductIds(options.productInstallationSelector);

                        $.getJSON('/job-installation/calendar',
                            {loc: $city.val(), iTypeId: $installationType.val(), pids: pids},
                            function(response){
                                if( response.success && response.data.calendar){
                                    INSTALLATION_CALENDAR = response.data.calendar;
                                }else{
                                    INSTALLATION_CALENDAR = {};
                                    Marb.Page.Toast.error({'text': options.error});
                                }
                                Mv2.Page.Checkout.Calendar.doCheckTime($calendar.val(), $calendar, $timeRange);
                            }
                        );
                    },
                    getSelectedProductIds: function getSelectedProductIds(elements){
                        var addOns = elements.map(
                            function(){
                                var val = $(this).val();
                                return val > 0 ? val : null;
                            }
                        ).get()
                            .join();

                        return addOns;
                    },
                    installationDateCheck: function installationDateCheck(date) {
                        if(!INSTALLATION_CALENDAR){
                            return;
                        }
                        var dayFormatted = Marb.Commons.Utils.formatDateyyyyMMdd(date);
                        var da = INSTALLATION_CALENDAR[dayFormatted];
                        var ret = {};
                        if( da ){
                            ret[0] = true;
                            ret[1] = '';
                            ret[2] = '';
                        }else{
                            ret[0] = false;
                            ret[1] = '';
                            ret[2] = '';
                        }
                        return ret;
                    },

                    doCheckTime: function doCheckTime(dateTxt, $calendar, $timeRange){
                        if(!INSTALLATION_CALENDAR){
                            return;
                        }
                        if(dateTxt.length != 10 ){
                            return;
                        }

                        var pi = $('#productInstallationId option:selected');
                        var isOnDemand = pi.data('ondemand');
                        if( isOnDemand ){
                            return;
                        }

                        var parts = dateTxt.split("/");
                        var key = parts[2] + "/" + parts[1] + "/" + parts[0];
                        var cal = INSTALLATION_CALENDAR[key];
                        if( cal ){
                            $timeRange.find('input').attr('disabled', true);
                            for(var i in cal.availableOn){
                                if( cal.availableOn[i] ){
                                    $timeRange.find('input[value='+i+']').attr('disabled',false);
                                }
                            }
                            $($timeRange.find('input:enabled')[0]).prop('checked', true);
                        }else{
                            $timeRange.find('input').attr('disabled',false);
                            $calendar.val('');
                        }
                    }
                }
            },
            Move: {
                 findCep:function findCep(options) {
                     const config = {
                         cepSelector: "",
                         cepError: "",
                         locationTxt: "",
                         locationValue: "",
                         locationError:"",
                         cepLocationError:"",
                         cepErrorTxt:"",
                         cepInvalidError:"",
                         onSuccess: function(data) {
                             if (!data.cep.locationDetail) {
                                 $(config.cepError).find('small').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> '+config.cepLocationError);
                                 $(config.cepError).show("drop", {direction: "up"});
                                 setTimeout(function () {
                                     $(config.cepError).hide("drop", {direction: "up"});
                                 }, 1500);
                                 $(config.locationTxt).val('');
                                 $(config.locationValue).val('');
                                 Materialize.Input.updateTextFields();
                                 return;
                             }
                             $(config.locationTxt).val(data.cep.locationDetail).blur();
                             config.streetResolver(data.cep.street.streetName);
                             $(config.locationValue).val(data.cep.locationId);
                             Materialize.Input.updateTextFields();
                         },
                         onError: function() {
                             $(config.cepError).find('small').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> '+config.cepErrorTxt);
                             $(config.cepError).show("drop", {direction: "up"});
                             setTimeout(function () {
                                 $(config.cepError).hide("drop", {direction: "up"});
                             }, 1500);
                             $(config.locationTxt).val('');
                             $(config.locationValue).val('');
                             Materialize.Input.updateTextFields();
                             return;
                         },
                         onValidationError: function() {
                             $(config.cepError).find('small').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> '+config.cepInvalidError);
                             $(config.cepError).show("drop", {direction: "up"});
                             setTimeout(function () {
                                 $(config.cepError).hide("drop", {direction: "up"});
                             }, 1500);
                             $(config.locationTxt).val('');
                             $(config.locationValue).val('');
                             Materialize.Input.updateTextFields();
                         },
                         streetResolver:function(street){

                         }
                     };
                     MarbV2.Commons.Util.findCep($.extend(config, options));
                 }
            },
            setAutocomplete : function(url, data, onSelect, dataTable) {
                var textId = '#' + data.textId;
                var valueId = '#' + data.valueId;
                var filter = data.filter || null;
                var trackResult = data.trackResult == false ? false : true;
                var isWarranty = data.isWarranty;
                var showEverythingElse = data.showEverythingElse;
                var jobId = data.jobId;
                if( data.textWatermark){
                    $(textId).watermark(data.textWatermark);
                }

                $(textId).on({
                    click: function(){
                        if( ! $(textId).attr('srch-clickd') ){
                            $(textId).attr('srch-clickd','true');
                            $(textId).val('');
                        }
                        $(textId).removeClass('error');
                    },
                    blur: function(){
                        if( $(textId).data('lastuniquevalue') ){
                            $(textId).val($(textId).data('lastuniquevalue'));
                            $(valueId).val($(valueId).data('lastuniquevalue'));
                        }else if( $(valueId).val() ){
                            $(textId).val( $(textId).data('lastvalue') );
                        }else{
                            $(textId).val("");
                        }
                    }
                });
                var container = $("<div class='ui-autocomplete-container' style='position: absolute; z-index: 9999;' ></div>");
                container.width($(textId).width());
                container.appendTo("body");
                $(textId).autocomplete({
                    minLength: 3,
                    delay: 300,
                    appendTo: container,
                    close: function(event, ui){
                        $(valueId).change();
                    },
                    select: function(event, ui){
                        $(valueId).val(ui.item.id);
                        if(onSelect){
                            dataTable.fnClearTable(0);
                            dataTable.fnDraw();
                        }

                    },
                    source: function(request, response){
                        var loading = $("<div class='input-loading'>&nbsp;</div>");
                        loading.appendTo("body");
                        loading.position({
                            my: 'right',
                            at: 'right-10',
                            of: $(textId)
                        });
                        var params = {term: request.term, filter: filter, jobId: jobId};
                        if(isWarranty){
                            params.isWarranty = isWarranty;
                        }
                        if(showEverythingElse !== undefined) {
                            params.showEverythingElse = showEverythingElse;
                        }
                        $.extend(params, data);
                        $.getJSON(url,params,function(queryResponse){
                            if(trackResult && request.term && request.term.length > 3){
                                Marb.Commons.Track.event('location-search', request.term, 'home');
                            }
                            loading.remove();
                            $(textId).data('lastuniquevalue','');
                            $(valueId).data('lastuniquevalue','');
                            if( queryResponse.success ){
                                var parentUl = $("<ul class='ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all'></ul>");
                                var parentLi = $('<li class="ui-menu-item">');
                                parentUl.append(parentLi);
                                var lengthDiv = $('<a class="ui-corner-all" tabindex="-1"></a>');
                                parentLi.append(lengthDiv);

                                var longestText = "";
                                var resultSize = queryResponse.data.length;
                                for(var i=0; i < resultSize; i++){
                                    var txt = queryResponse.data[i].label;
                                    if( txt.length > longestText.length ){
                                        longestText = txt;
                                    }
                                }
                                if( resultSize == 1 ){
                                    $(textId).data('lastuniquevalue',queryResponse.data[0].label);
                                    $(valueId).data('lastuniquevalue',queryResponse.data[0].id);
                                }
                                lengthDiv.text(longestText);
                                parentUl.appendTo('body');
                                var width = lengthDiv.width();
                                parentUl.remove();
                                if( $(window).width() > 640 ){
                                    container.width(width*1.25);
                                }

                                response(queryResponse.data);
                            }else{
                                response();
                            }
                        });
                    },
                    focus: function(event, ui){
                        $(textId).val(ui.item.label);
                        $(valueId).val(ui.item.id);
                        $(textId).data('lastvalue', ui.item.label);
                    }
                });
            },
        }
    };
    return marb;
})();
var Mv2 = MarbV2;
